import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { DEFAULT_STATS, formatLastProcessed } from './knowledgeBaseUtils';

const formatCount = (value) => Number(value || 0).toLocaleString();

const STAT_META = [
  { key: 'totalChunks', label: 'Total chunks', icon: DescriptionOutlinedIcon, format: formatCount },
  { key: 'sources', label: 'Sources', icon: SmartphoneOutlinedIcon, format: formatCount },
  {
    key: 'pagesSlidesUrls',
    label: 'Pages / Slides / URLs',
    icon: LayersOutlinedIcon,
    format: formatCount,
  },
  {
    key: 'lastProcessed',
    label: 'Last processed',
    icon: AccessTimeOutlinedIcon,
    format: formatLastProcessed,
  },
];

const KnowledgeStatsCards = ({ stats = DEFAULT_STATS }) => (
  <Box display='grid' gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr', lg: 'repeat(4, 1fr)' }} gap={2} mb={2.5}>
    {STAT_META.map(({ key, label, icon: Icon, format }) => (
      <Card key={key} variant='outlined' sx={{ borderRadius: 2, borderColor: 'divider', boxShadow: 'none' }}>
        <CardContent sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 2, '&:last-child': { pb: 2 } }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1.5,
              bgcolor: 'rgba(25, 118, 210, 0.08)',
              color: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Icon fontSize='small' />
          </Box>
          <Box minWidth={0}>
            <Typography variant='body2' color='text.secondary' mb={0.25}>
              {label}
            </Typography>
            <Typography
              variant='h6'
              fontWeight={700}
              lineHeight={1.25}
              sx={{ fontSize: key === 'lastProcessed' ? 16 : undefined, wordBreak: 'break-word' }}
            >
              {format(stats?.[key])}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    ))}
  </Box>
);

export default KnowledgeStatsCards;
